import { render } from "./CelestialCards.vue?vue&type=template&id=7dc523c7&scoped=true"
import script from "./CelestialCards.vue?vue&type=script&lang=js"
export * from "./CelestialCards.vue?vue&type=script&lang=js"

import "./CelestialCards.vue?vue&type=style&index=0&id=7dc523c7&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src310475096/src/AstopiaAdminPanel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7dc523c7"]])

export default __exports__